import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the occupants list when a payroll update operation is successfully
 * executed, to reflect the changes.
 */
export const reloadOnPayrollsUpdate = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(() =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from('(effect) reload on payrolls update')
            .create(),
        ),
      ),
)
